var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13131_11958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2262 37.5833H46.0596V42.9999H50.2262V37.5833Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1429 57.1666H50.2263V62.5833H58.1429V57.1666Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0596 48.8333V53.4166H38.5596V62.5833H43.5596V57.1666H50.2262V48.8333H46.0596Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7262 37.5833H58.1429V42.9999H62.7262V37.5833Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7262 48.8333H58.1429V57.1666H62.7262V48.8333Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1429 43.4166H50.2263V48.8333H58.1429V43.4166Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5596 18.4166V35.0833H35.2262V18.4166H18.5596ZM30.6429 30.9166H22.7262V22.5833H30.6429V30.9166Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0596 18.4166V35.0833H62.7262V18.4166H46.0596ZM58.1429 30.9166H50.2262V22.5833H58.1429V30.9166Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5596 45.5V62.1667H35.2262V45.5H18.5596ZM30.6429 58H22.7262V49.6667H30.6429V58Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7262 37.5833H18.5596V42.1666H22.7262V37.5833Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3096 37.5833H43.5596V48.8333H38.1429V42.5833H32.3096V37.5833Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5596 23.8333H38.5596V35.0833H43.5596V23.8333Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 11.3333V23.8333H7.30957V12.5833C7.30957 11.3333 7.72624 9.66663 8.97624 8.83329C9.80957 7.58329 11.4762 7.16663 12.7262 7.16663H23.9762V11.3333H11.4762Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5596 7.16663C70.2262 7.16663 71.4762 7.58329 72.3096 8.83329C73.5596 9.66663 73.9762 11.3333 73.9762 12.5833V23.8333H69.8096V11.3333H57.3096V7.16663H68.5596Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 57.1666V69.6666H23.9762V73.8333H12.7262C11.0596 73.8333 9.80957 73.4166 8.97624 72.1666C7.72624 71.3333 7.30957 69.6666 7.30957 68.4166V57.1666H11.4762Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8096 69.6666V57.1666H73.9762V68.4166C73.9762 70.0833 73.5596 71.3333 72.3096 72.1666C71.4762 73.4166 69.8096 73.8333 68.5596 73.8333H57.3096V69.6666H69.8096Z",
    fill: "#C84B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13131_11958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6667,
    height: 66.6667,
    fill: "white",
    transform: "translate(7.30957 7.16663)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/qr-scan.3980ea18274488d724b5dc1263af9557.svg";
export { ForwardRef as ReactComponent };